
import React, { Fragment } from 'react';
import { Translate } from '../contexts/Language';
import { memoize } from 'react-data-table-component';

export const DataTableColumns = {
  cryptoWallet: [
    {
      name: Translate("Login"),
      selector: 'login',
      cell: d => <b>#{d.login}</b>,
      width: '100px'
    },
    {
      name: Translate("Coin"),
      selector: 'coin',
      width: '50px',
      cell: d => (d.coin === "BTC" ? <span className="text-warning"><i className="fab fa-bitcoin"></i></span> : <span>{d.coin}</span>)
    },
    {
      name: Translate("Date"),
      selector: 'date',
      sortable: true,
      width: '150px'
    },
    {
      name: Translate("Comment"),
      selector: 'comment',
      width: '150px',
    },
    {
      name: Translate("Confirmation"),
      selector: 'confirmation',
      width: '100px',
      cell: d => (d.confirmation > 2 ? <span className="badge pb-1 font-12 payment-status badge-info">✓</span> : <span className="badge pb-1 font-12 payment-status badge-warning">{d.confirmation}</span>)
    },
    {
      name: Translate("Amount"),
      selector: 'amount',
      width: '150px',
      cell: d => (d.amount >= 0 ? <span className="badge pb-1 font-12 badge-success">{d.amount}</span> : <span className="badge pb-1 font-12 badge-danger">{d.amount}</span>)
    },
    {
      name: Translate("Fee"),
      selector: 'fee',
      width: '150px',
      cell: d => (d.fee >= 0 ? <span className="badge pb-1 font-12 badge-success">{d.fee}</span> : <span className="badge pb-1 font-12 badge-danger">{d.fee}</span>)
    },
    {
      name: Translate("To Address"),
      selector: 'toAddress'
    },
    {
      name: Translate("TxID"),
      selector: 'txID',
      cell: d => <span><a href={"https://www.blockchain.com/btc/tx/" + d.txID}>{d.txID.substring(0, 35)}...</a></span>
    }
  ],
  cryptoWalletERC20: [
    {
      name: Translate("Login"),
      selector: 'login',
      cell: d => <b>#{d.login}</b>,
      width: '100px'
    },
    {
      name: Translate("Coin"),
      selector: 'coin',
      width: '50px',
      cell: d => (d.coin === "USDT" ? <span className="text-warning"><i className="fa fa-usd"></i></span> : <span>{d.coin}</span>)
    },
    {
      name: Translate("Date"),
      selector: 'date',
      sortable: true,
      width: '150px'
    },
    {
      name: Translate("Comment"),
      selector: 'comment',
      width: '150px',
    },
    {
      name: Translate("Confirmation"),
      selector: 'confirmation',
      width: '100px',
      cell: d => (d.confirmation > 2 ? <span className="badge pb-1 font-12 payment-status badge-info">✓</span> : <span className="badge pb-1 font-12 payment-status badge-warning">{d.confirmation}</span>)
    },
    {
      name: Translate("Amount"),
      selector: 'amount',
      width: '150px',
      cell: d => (d.amount >= 0 ? <span className="badge pb-1 font-12 badge-success">{d.amount}</span> : <span className="badge pb-1 font-12 badge-danger">{d.amount}</span>)
    },
    {
      name: Translate("Fee"),
      selector: 'fee',
      width: '150px',
      cell: d => (d.fee >= 0 ? <span className="badge pb-1 font-12 badge-success">{d.fee}</span> : <span className="badge pb-1 font-12 badge-danger">{d.fee}</span>)
    },
    {
      name: Translate("To Address"),
      selector: 'toAddress'
    },
    {
      name: Translate("TxID"),
      selector: 'txID',
      cell: d => <span><a href={"https://etherscan.io/tx/" + d.txID}>{d.txID.substring(0, 35)}...</a></span>
    }
  ],
  cryptoWalletTRC20: [
    {
      name: Translate("Login"),
      selector: 'login',
      cell: d => <b>#{d.login}</b>,
      width: '100px'
    },
    {
      name: Translate("Coin"),
      selector: 'coin',
      width: '50px',
      cell: d => (d.coin === "USDT" ? <span className="text-warning"><i className="fa fa-usd"></i></span> : <span>{d.coin}</span>)
    },
    {
      name: Translate("Date"),
      selector: 'date',
      sortable: true,
      width: '150px'
    },
    {
      name: Translate("Comment"),
      selector: 'comment',
      width: '150px',
    },
    {
      name: Translate("Confirmation"),
      selector: 'confirmation',
      width: '100px',
      cell: d => (d.confirmation > 2 ? <span className="badge pb-1 font-12 payment-status badge-info">✓</span> : <span className="badge pb-1 font-12 payment-status badge-warning">{d.confirmation}</span>)
    },
    {
      name: Translate("Amount"),
      selector: 'amount',
      width: '150px',
      cell: d => (d.amount >= 0 ? <span className="badge pb-1 font-12 badge-success">{d.amount}</span> : <span className="badge pb-1 font-12 badge-danger">{d.amount}</span>)
    },
    {
      name: Translate("Fee"),
      selector: 'fee',
      width: '150px',
      cell: d => (d.fee >= 0 ? <span className="badge pb-1 font-12 badge-success">{d.fee}</span> : <span className="badge pb-1 font-12 badge-danger">{d.fee}</span>)
    },
    {
      name: Translate("To Address"),
      selector: 'toAddress'
    },
    {
      name: Translate("TxID"), 
      selector: 'txID',
      cell: d => <span><a href={"https://tronscan.org/#/transaction/" + d.txID}>{d.txID.substring(0, 35)}...</a></span>
    }
  ],
  subListTRC20: [
    {
      name: Translate("Login"),
      selector: 'login',
      cell: d => <b>#{d.login}</b>,
      sortable: true,
      width: '150px',
    },
    {
      name: Translate("Address"),
      selector: 'address',
    },
    {
      name: Translate("TRX"),
      selector: 'balanceTRX',
      sortable: true,
      width: '200px',
    },
    {
      name: Translate("USDT"),
      selector: 'balanceUSDT',
      sortable: true,
      width: '200px',
    },
  ],
  subListERC20: [
    {
      name: Translate("Login"),
      selector: 'login',
      cell: d => <b>#{d.login}</b>,
      sortable: true,
      width: '150px',
    },
    {
      name: Translate("Address"),
      selector: 'address',
    },
    {
      name: Translate("ETH"),
      selector: 'balanceETH',
      sortable: true,
      width: '200px',
    },
    {
      name: Translate("USDT"),
      selector: 'balanceUSDT',
      sortable: true,
      width: '200px',
    },
  ],
  transferHistory: [
    {
      name: Translate("Login"),
      selector: 'login',
      cell: d => <b>#{d.login}</b>,
      width: '100px'
    },
    {
      name: Translate("PSP"),
      selector: 'psp',
      cell: d => <span><img src={"/assets/psp-logo/" + (d.transferOptionLogo || "defaultlogo.svg")} alt="" width="30" className="mb-1" />&nbsp; {d.transferOptionTitle}</span>,
      minWidth: '150px'
    },
    {
      name: Translate("Amount"),
      selector: 'amount',
      width: '100px',
      cell: d => (d.currency === "BTC" ? d.amount : d.amount.toFixed(2).format('c'))
    },
    {
      name: Translate("Currency"),
      selector: 'currency',
      width: '100px'
    },
    {
      name: Translate("Status"),
      selector: 'status',
      sortable: true,
      cell: d => <span className={"badge pb-1 font-12 payment-status " + d.statusClass}>{Translate(d.statusTitle)}</span>
    },
    {
      name: Translate("Date"),
      selector: 'insertDate'
    },
    {
      name: Translate('Type'),
      selector: 'type',
      width: '100px',
      cell: d => (d.type === "Deposit" ? <span className="badge pb-1 font-12 payment-status badge-success">Deposit</span> : <span className="badge pb-1 font-12 payment-status badge-warning">Withdrawal</span>)
    }
  ],
  transferOptionsRoles: memoize((onDelete, onEdit) => [
    {
      name: Translate('Login'),
      selector: 'login',
      sortable: true
    },
    {
      name: Translate('Options'),
      sortable: true,
      center: true,
      cell: d => d.transferType.map((item, index) => (item === "" ? item : <span key={index} className="badge badge-light m-1">{Translate(item)}</span>))
    },
    {
      name: Translate('Action'),
      right: true,
      minWidth: '200px',
      cell: d => {
        return (
          <span className="text-nowrap">
            <button type="button" className="btn btn-danger btn-sm waves-effect waves-light mr-1" title={Translate('Delete')} onClick={e => onDelete(d.login)}><i className="far fa-trash-alt"></i> Delete</button>
            <button type="button" className="btn btn-dark btn-sm waves-effect waves-light" title={Translate('Edit')} onClick={e => onEdit(d.login)}><i className="far fa-edit"></i> Edit</button>
          </span>

        )
      }
    }
  ]),
  transferOptionsBlackList: memoize((onDelete, onEdit) => [
    {
      name: Translate('Id'),
      selector: 'id',
      sortable: true,
      maxWidth: '50px',
      cell: d => <b>#{d.id}</b>
    },
    {
      name: Translate('PSP'),
      sortable: true,
      cell: d => {
        return (<span><img src={"/assets/psp-logo/" + (d.transferOptionLogo || "defaultlogo.svg")} alt="" width="30" className="mb-1" />&nbsp; {d.transferOptionTitle}</span>)
      }
    },
    {
      name: Translate('Login'),
      selector: 'login',
      sortable: true
    },
    {
      name: Translate('Options'),
      sortable: true,
      center: true,
      cell: d => <span> {d.transferType === "D" || d.transferType === "B" ? <span className="badge badge-light m-1">{Translate("Deposit")}</span> : ""} {d.transferType === "W" || d.transferType === "B" ? <span className="badge badge-light m-1">{Translate("Withdrawal")}</span> : ""}</span>
    },
    {
      name: Translate('Action'),
      right: true,
      minWidth: '200px',
      cell: d => {
        return (
          <span>
            <button type="button" className="btn btn-danger btn-sm waves-effect waves-light" title={Translate('Delete')} onClick={e => onDelete(d.id)}><i className="far fa-trash-alt"></i> Delete</button> &nbsp; <button type="button" className="btn btn-dark btn-sm waves-effect waves-light" title={Translate('Edit')} onClick={e => onEdit(d.id)}><i className="far fa-edit"></i> Edit</button>
          </span>

        )
      }
    }
  ]),
  transferOptionsWhiteList: memoize((onDelete, onEdit) => [
    {
      name: Translate('Id'),
      selector: 'id',
      sortable: true,
      maxWidth: '50px',
      cell: d => <b>#{d.id}</b>
    },
    {
      name: Translate('PSP'),
      sortable: true,
      cell: d => {
        return (<span><img src={"/assets/psp-logo/" + (d.transferOptionLogo || "defaultlogo.svg")} alt="" width="30" className="mb-1" />&nbsp; {d.transferOptionTitle}</span>)
      }
    },
    {
      name: Translate('Country'),
      sortable: true,
      cell: d => {
        return (<span className="capitalize">{<img src={d.countryFlag} alt="Flag" width="24" className="mb-1 mr-1" onError={(e) => e.target.src = '/assets/images/flags/null.png'} />} {d.country}</span>)
      }
    },
    {
      name: Translate('Options'),
      sortable: true,
      center: true,
      cell: d => <span> {(d.transferType === "D" || d.transferType === "B") ? <span className="badge badge-light m-1">{Translate("Deposit")}</span> : ""} {(d.transferType === "W" || d.transferType === "B") ? <span className="badge badge-light m-1">{Translate("Withdrawal")}</span> : ""}</span>
    },
    {
      name: Translate('Action'),
      right: true,
      minWidth: '200px',
      cell: d => {
        return (
          <span>
            <button type="button" className="btn btn-danger btn-sm waves-effect waves-light" title={Translate('Delete')} onClick={e => onDelete(d.id)}><i className="far fa-edit"></i> Delete</button> &nbsp; <button type="button" className="btn btn-dark btn-sm waves-effect waves-light" title={Translate('Edit')} onClick={e => onEdit(d.id)}><i className="far fa-edit"></i> Edit</button>
          </span>

        )
      }
    }
  ]),
  transferOptionsRules: memoize((onEdit, onDelete) => [
    {
      name: Translate('Id'),
      selector: 'id',
      sortable: true,
      maxWidth: '50px',
      cell: d => <b>#{d.id}</b>
    },
    {
      name: Translate('PSP'),
      sortable: true,
      cell: d => {
        return (<span><img src={"/assets/psp-logo/" + (d.transferOptionLogo || "defaultlogo.svg")} alt="" width="30" className="mb-1" />&nbsp; {d.transferOptionTitle}</span>)
      }
    },
    {
      name: Translate('Description'),
      selector: 'ruleDescription',
      sortable: true,
    },
    {
      name: Translate('Options'),
      sortable: true,
      center: true,
      cell: d => <span className="badge badge-light m-1">{Translate((d.transferType === "d" ? "Deposit" : "Withdrawal"))}</span>
    },
    {
      name: Translate('Action'),
      right: true,
      minWidth: '200px',
      cell: d => {
        return (
          <span>
            <button type="button" className="btn btn-danger btn-sm waves-effect waves-light" title={Translate('Delete')} onClick={e => onDelete(d.id)}><i className="far fa-edit"></i> {Translate("Delete")}</button> &nbsp; <button type="button" className="btn btn-dark btn-sm waves-effect waves-light" title={Translate('Edit')} onClick={e => onEdit(d.id)}><i className="far fa-edit"></i> {Translate("Edit")}</button>
          </span>

        )
      }
    }
  ]),
  transferOptions: memoize((onEdit) => [
    {
      name: Translate('Id'),
      selector: 'id',
      sortable: true,
      maxWidth: '50px',
      cell: d => <b>#{d.id}</b>
    },
    {
      name: Translate('Title'),
      selector: 'title',
      sortable: true,
      cell: d => {

        let url = (d.outside ? d.url : "https://react.customer.artsmrkts.com/deposit/" + d.url);

        return (<a href={url} target="_blank" rel="noopener noreferrer"><img src={"/assets/psp-logo/" + (d.logo || "defaultlogo.svg")} alt="" width="30" className="mb-1" />&nbsp; {d.title}</a>)
      }
    },
    {
      name: Translate('Description'),
      selector: 'description',
      sortable: true,
    },
    {
      name: Translate('Accepted Currencies'),
      selector: 'acceptedCurrencies',
      sortable: true,
      center: true,
      cell: d => d.acceptedCurrencies.map(item => (
        <span key={item} className="badge badge-light m-1">{Translate(item)}</span>
      ))
    },
    {
      name: Translate('Processing Time / Fee'),
      sortable: true,
      center: true,
      cell: d => <span><span className="badge badge-light m-1">{Translate(d.processingTime)}</span><span className="badge badge-light m-1">{Translate(d.fee)}</span></span>
    },
    {
      name: Translate('Options'),
      sortable: true,
      center: true,
      cell: d => <span> {d.deposit ? <span className="badge badge-light m-1">{Translate("Deposit")}</span> : ""} {d.withdrawal ? <span className="badge badge-light m-1">{Translate("Withdrawal")}</span> : ""}</span>
    },
    {
      name: Translate('Auto Transfer'),
      selector: 'auto',
      cell: d => (d.auto ? <span className="badge pb-1 font-12 payment-status badge-success">{Translate('Auto')}</span> : <span className="badge pb-1 font-12 payment-status badge-danger">{Translate('Manual')}</span>),
    },
    {
      name: Translate('Action'),
      right: true,
      minWidth: '200px',
      cell: d => {
        return (<button type="button" className="btn btn-dark btn-sm waves-effect waves-light" title={Translate('Edit')} onClick={e => onEdit(d.id)}><i className="far fa-edit"></i> Edit</button>)
      }
    }
  ]),
  transferOptionsTab: [
    {
      name: Translate('Id'),
      selector: 'id',
      sortable: true,
      maxWidth: '50px',
      cell: d => <b>#{d.id}</b>
    },
    {
      name: Translate('Title'),
      selector: 'title',
      sortable: true,
      cell: d => {

        let url = (d.outside ? d.url : "https://react.customer.artsmrkts.com/deposit/" + d.url);

        return (<a href={url} target="_blank" rel="noopener noreferrer"><img src={"/assets/psp-logo/" + (d.logo || "defaultlogo.svg")} alt="" width="30" className="mb-1" />&nbsp; {d.title}</a>)
      }
    },
    {
      name: Translate('Description'),
      selector: 'description',
      sortable: true,
    },
    {
      name: Translate('Accepted Currencies'),
      selector: 'acceptedCurrencies',
      sortable: true,
      center: true,
      cell: d => d.acceptedCurrencies.map(item => (
        <span key={item} className="badge badge-light m-1">{Translate(item)}</span>
      ))
    },
    {
      name: Translate('Processing Time / Fee'),
      sortable: true,
      center: true,
      cell: d => <span><span className="badge badge-light m-1">{Translate(d.processingTime)}</span><span className="badge badge-light m-1">{Translate(d.fee)}</span></span>
    }
  ],
  deposit: memoize((onConfirm, onDetail, onCancel) => [
    {
      name: Translate('Id'),
      selector: 'id',
      sortable: true,
      maxWidth: '50px',
      cell: d => <b>#{d.id}</b>
    },
    {
      name: Translate('Login'),
      selector: 'login',
      maxWidth: '50px',
      sortable: true,
      cell: d => (d.alert ? <span className="badge badge-danger font-12 p-2" title={Translate("Deposit Alert")}><b><i className="fas fa-exclamation-triangle mr-1"></i> {d.login}</b></span> : <span>{d.login}</span>)
    },
    {
      name: Translate('Fullname'),
      selector: 'fullname',
    },
    {
      name: Translate('MetaStatus'),
      selector: 'metaStatus',
    },
    {
      name: Translate('PSP'),
      selector: 'transferOption',
      sortable: true,
      cell: d => <span><img src={"/assets/psp-logo/" + (d.transferLogo || "defaultlogo.svg")} alt="" width="30" className="mb-1" />&nbsp; {d.transferOption}</span>
    },
    {
      name: Translate('Amount'),
      selector: 'amount',
      sortable: true,
      cell: d => (d.transferCurrency === "BTC" ? <span>{d.amount} {d.transferCurrency}</span> : <span>{d.amount.toFixed(2).format('c')} {d.transferCurrency}</span>)
    },
    {
      name: Translate('Status'),
      selector: 'status',
      sortable: true,
      cell: d => <span className={"badge pb-1 font-12 payment-status " + d.statusClass}>{Translate(d.statusTitle)}</span>
    },
    {
      name: Translate('Date'),
      selector: 'insertDate',
      sortable: true,
    },
    {
      name: Translate('Comment'),
      selector: 'comment',
      sortable: false,
      cell: d => {
        let jsonComment = d.comment ? JSON.parse(d.comment) : "";
        let comment = jsonComment ? jsonComment.Comment : "";
        return <span className="text-ellipsis">{comment}</span>
      }
    },
    {
      name: Translate('Action'),
      right: true,
      cell: d => {

        let manualButton = (d.statusTitle === "Manual" ? <button type="button" className="btn btn-success btn-sm waves-effect waves-light" title={Translate('Confirm Deposit')} onClick={e => onConfirm(d.transactionId)}><i className="far fa-check-circle"></i></button> : ""),
          cancelbutton = d.statusTitle === "Manual" ? <button type="button" className="btn btn-danger btn-sm waves-effect waves-light" title={Translate('Cancel Withdraw')} onClick={e => onCancel(d.transactionId)}><i className="far fa-times-circle"></i></button> : null,
          detailButton = <button type="button" className="btn btn-dark btn-sm waves-effect waves-light" title={Translate('Deposit Detail')} onClick={e => onDetail(d.transactionId)}><i className="far fa-list-alt"></i></button>

        return (<span className="text-nowrap">
          {manualButton} {cancelbutton} {detailButton}
        </span>)
      }
    }
  ]),
  withdrawal: memoize((onConfirm, onCancel, onDetail) => [
    {
      name: Translate('Id'),
      selector: 'id',
      sortable: true,
      maxWidth: '50px',
      cell: d => <b>#{d.id}</b>
    },
    {
      name: Translate('Login'),
      selector: 'login',
      maxWidth: '50px',
      sortable: true,
      cell: d => (d.alert ? <span className="badge badge-danger font-12 p-2" title={Translate("Withdrawal Alert")}><b><i className="fas fa-exclamation-triangle mr-1"></i> {d.login}</b></span> : <span>{d.login}</span>)
    },
    {
      name: Translate('MetaStatus'),
      selector: 'metaStatus',
      maxWidth: '150px'
    },
    {
      name: Translate('Amount'),
      selector: 'amount',
      sortable: true,
      cell: d => (d.transferCurrency === "BTC" ? <span>{d.amount} {d.transferCurrency}</span> : <span>{d.amount.toFixed(2).format('c')} {d.transferCurrency}</span>),
      maxWidth: '150px'
    },
    {
      name: Translate('Common'),
      selector: 'common',
      minWidth: '400px',
      cell: d => {

        let jsonTransferDetail = d.transferDetail ? JSON.parse(d.transferDetail) : "";
        return <dl className="row dl-striped img-thumbnail mt-3 p-0">
          <dt className="col-sm-5"><span className={"badge pb-1 font-12 payment-status " + d.statusClass}>{Translate(d.statusTitle)}</span></dt>
          <dd className="col-sm-7"><img src={"/assets/psp-logo/" + d.transferLogo} alt="" width="14" /> {d.transferOption}</dd>
          <dt className="col-sm-5 text-capitalize">{Translate("Fullname")}</dt>
          <dd className="col-sm-7">{Translate(d.fullname)}</dd>
          {Object.keys(jsonTransferDetail).map(key => (
            <Fragment key={key}>
              <dt className="col-sm-5 text-capitalize">{key.replace(/_/g, " ")}</dt>
              <dd className="col-sm-7">{jsonTransferDetail[key]}</dd>
            </Fragment>
          ))}
        </dl>
      },
      cellExport: d => {
        let jsonTransferDetail = d.transferDetail ? JSON.parse(d.transferDetail) : {};

        let exportData = {
          [d.statusTitle]: d.transferOption,
          Fullname: d.fullname,
        }

        Object.keys(jsonTransferDetail).forEach(key => {
          if (jsonTransferDetail[key]) {
            exportData[key] = jsonTransferDetail[key];
          }
        });

        return exportData;
      }
    },
    {
      name: Translate('Date'),
      selector: 'insertDate',
      sortable: true,
    },
    {
      name: Translate('Comment'),
      selector: 'comment',
      sortable: false,
      cell: d => {
        let jsonComment = d.comment ? JSON.parse(d.comment) : "";
        let comment = jsonComment ? jsonComment["Comment"] : "";
        return <span className="text-ellipsis">{comment}</span>
      }
    },
    {
      name: Translate('Comm'),
      sortable: true,
      cell: d => {
        let common = d.common ? JSON.parse(d.common) : {};
        return <span title="Commission">{common["Commission"]}</span>
      },
      maxWidth: '50px'
    },
    {
      name: Translate('Action'),
      right: true,
      cell: d => 
        {

        let manualButton = d.statusTitle === "Pending" ? <button type="button" className="btn btn-success btn-sm waves-effect waves-light" title={Translate('Confirm Withdraw')} onClick={e => onConfirm(d.transactionId)}><i className="far fa-check-circle"></i></button> : null;
        let cancelbutton = d.statusTitle === "Pending" ? <button type="button" className="btn btn-danger btn-sm waves-effect waves-light" title={Translate('Cancel Withdraw')} onClick={e => onCancel(d.transactionId)}><i className="far fa-times-circle"></i></button> : null;
        let detailButton = <button type="button" className="btn btn-dark btn-sm waves-effect waves-light" title={Translate('Withdraw Detail')} onClick={e => onDetail(d.transactionId)}><i className="far fa-list-alt"></i></button>;

        return (<span className="text-nowrap">
          {manualButton} {cancelbutton} {detailButton}
        </span>)
      }
    }
  ]),
  internalTransfer: memoize((onConfirm, onDetail, onCancel) => [
    {
      name: Translate('Id'),
      selector: 'id',
      sortable: true,
      maxWidth: '50px',
      cell: d => <b>#{d.id}</b>
    },
    {
      name: Translate('BossID'),
      selector: 'bossId',
      sortable: true
    },
    {
      name: Translate('From Account'),
      selector: 'fromAccount',
    },
    {
      name: Translate('From Amount'),
      selector: 'fromAmount',
      cell: d => (d.fromAccountCurrency === "BTC" ? <span>{d.fromAmount} {d.fromAccountCurrency}</span> : <span>{d.fromAmount.toFixed(2).format('c')} {d.fromAccountCurrency}</span>)
    },
    {
      name: Translate('To Account'),
      selector: 'toAccount'
    },
    {
      name: Translate('To Amount'),
      selector: 'toAmount',
      cell: d => (d.toAccountCurrency === "BTC" ? <span>{d.toAmount} {d.fromAccountCurrency}</span> : <span>{d.toAmount.toFixed(2).format('c')} {d.toAccountCurrency}</span>)
    },
    {
      name: Translate('Status'),
      selector: 'status',
      cell: d => <span className={"badge pb-1 font-12 payment-status " + d.statusClass}>{Translate(d.statusTitle)}</span>
    },
    {
      name: Translate('Date'),
      selector: 'insertDate',
      sortable: true,
    },
    {
      name: Translate('Comment'),
      selector: 'comment',
      sortable: false,
      cell: d => {
        let jsonComment = d.comment ? JSON.parse(d.comment) : "";
        let comment = jsonComment ? jsonComment.Comment : "";
        return <span className="text-ellipsis">{comment}</span>
      }
    },
    {
      name: Translate('Action'),
      right: true,
      cell: d => {

        let manualButton = (d.statusTitle === "Manual" ? <button type="button" className="btn btn-success btn-sm waves-effect waves-light" title={Translate('Confirm Transfer')} onClick={e => onConfirm(d.transactionId)}><i className="far fa-check-circle"></i></button> : ""),
          detailButton = <button type="button" className="btn btn-dark btn-sm waves-effect waves-light" title={Translate('Deposit Detail')} onClick={e => onDetail(d.transactionId)}><i className="far fa-list-alt"></i></button>,
          cancelbutton = d.statusTitle === "Manual" ? <button type="button" className="btn btn-danger btn-sm waves-effect waves-light" title={Translate('Cancel Withdraw')} onClick={e => onCancel(d.transactionId)}><i className="far fa-times-circle"></i></button> : null

        return (<span className="text-nowrap">
          {manualButton} {cancelbutton} {detailButton}
        </span>)
      }
    }
  ]),
  userList: memoize((onEdit, onDelete) => [
    {
      name: Translate('Id'),
      selector: 'id',
      sortable: true,
      maxWidth: '50px',
      cell: d => <b>#{d.id}</b>
    },
    {
      name: Translate('Firstname'),
      selector: 'firstName',
      sortable: true
    },
    {
      name: Translate('Lastname'),
      selector: 'lastName',
    },
    {
      name: Translate('CreateDate'),
      selector: 'createDate',
    },
    {
      name: Translate('Status'),
      selector: 'status',
      cell: d => d.status ? <span className="badge pb-1 font-12 payment-status badge-success">{Translate("Active")}</span> : <span className="badge pb-1 font-12 payment-status badge-danger" >{Translate("Passive")}</span>
    },
    {
      name: Translate('Last Login'),
      selector: 'lastLogin'
    },
    {
      name: Translate('Role'),
      selector: 'role',
      cell: d => {
        if (d.role === 0) { return <span className="badge pb-1 font-12 payment-status badge-success">{Translate("Admin")}</span> }
        else if (d.role === 1) { return <span className="badge pb-1 font-12 payment-status badge-warning">{Translate("Personnel")}</span> }
        else if (d.role === 2) { return <span className="badge pb-1 font-12 payment-status badge-info">{Translate("Currency Manager")}</span> }
        else if (d.role === 3) { return <span className="badge pb-1 font-12 payment-status badge-info">{Translate("Report Manager")}</span> }
      }
      //   d => d.isAdmin ?  <span className="badge pb-1 font-12 payment-status badge-success">{Translate("Admin")}</span> : <span className="badge pb-1 font-12 payment-status badge-warning" >{Translate("User")}</span> 
    },
    {
      name: Translate('Action'),
      right: true,
      cell: d => {

        let editbutton = <button type="button" className="btn btn-dark btn-sm waves-effect waves-light" title={Translate('Edit User')} onClick={e => onEdit(d.id)}><i className="far fa-list-alt"></i></button>,
          deleteButton = <button type="button" className="btn btn-danger btn-sm waves-effect waves-light" title={Translate('Delete User')} onClick={e => onDelete(d.id)}><i className="far fa-times-circle"></i></button>

        return (<span className="text-nowrap">
          {editbutton} {deleteButton}
        </span>)
      }
    }
  ]),
  documentList: memoize((onDetail) => [
    {
      name: Translate('Login'),
      selector: 'login',
      sortable: true
    },
    {
      name: Translate('Fullname'),
      selector: 'fullname',
      sortable: true,
    },
    {
      name: Translate('CreateDate'),
      selector: 'createDate',
      sortable: true,
    },
    {
      name: Translate('Status'),
      selector: 'status',
      sortable: true,
      cell: d => d.status ? <span className="badge pb-1 font-12 payment-status badge-success">{Translate("Approved")}</span> : <span className="badge pb-1 font-12 payment-status badge-info" >{Translate("Pending")}</span>
    },
    {
      name: Translate('Action'),
      right: true,
      cell: d => {

        let editbutton = <button type="button" className="btn btn-dark btn-sm waves-effect waves-light" title={Translate('Show Uploaded Image')} onClick={e => onDetail(d.login)}><i className="far fa-list-alt"></i></button>
        return (<span className="text-nowrap">
          {editbutton}
        </span>)
      }
    },
  ]),
  documentTable: [
    {
      name: Translate('Name'),
      selector: 'name',
      width: '350px',
      sortable: true,
    },
    {
      name: Translate('Type'),
      selector: 'type',
      sortable: true,
    },
    {
      name: Translate('Size'),
      selector: 'size',
      sortable: true,
      cell: d=> <span>{d.size} KB</span>
    },
    {
      name: Translate('Action'),
      right: true,
      cell: d => {
        let editbutton = (<button type="button" className="btn btn-dark btn-sm waves-effect waves-light" title={Translate('Show Uploaded Image')} onClick={e => {
          const byteCharacters = atob(d.image.fileContents);

          const byteNumbers = new Array(byteCharacters.length);

          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }

          const byteArray = new Uint8Array(byteNumbers);

          const file = new Blob([byteArray], { type: d.image.contentType });
          const link = document.createElement('a');

          link.id = `_download_file_${d.name}`;
          link.download = d.name;
          link.href = window.URL.createObjectURL(file);

          document.body.appendChild(link);

          link.click();

          document.getElementById(link.id).remove();
        }}><i className="fas fa-cloud-download-alt"></i></button>)
        return (<span className="text-nowrap">
          {editbutton}
        </span>)
      },
    },
  ],
  coinAddressList:  [
    {
      name: Translate('Id'),
      selector: 'id',
      sortable: true,
      maxWidth: '50px',
      cell: d => <b>#{d.id}</b>
    },
    {
      name: Translate('Login'),
      selector: 'login',
      sortable: true
    },
    {
      name: Translate('Address'),
      selector: 'address',
    },
    {
      name: Translate('CreateDate'),
      selector: 'createDate',
    },
    {
      name: Translate('Status'),
      selector: 'status',
      cell: d => d.status ? <span className="badge pb-1 font-12 payment-status badge-success">{Translate("Active")}</span> : <span className="badge pb-1 font-12 payment-status badge-danger" >{Translate("Passive")}</span>
    },    
  ],
}